<main class="auth auth--centered">
  <section class="auth__panel auth__panel--wide">
    <div class="auth__card auth__card--centered">

      <span class="auth__mark-mobile">
        <svg width="44" height="44" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs>
            <clipPath id="frameLogout"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
          </defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#1F4B3F" stroke-width="4.5"></rect>
          <g clip-path="url(#frameLogout)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#C2A461" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#1F4B3F" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#1F4B3F" stroke-width="3.6" stroke-linecap="round"></path>
            <path d="M26 96 Q45 87 62 96 T98 95" stroke="#C2A461" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
      </span>

      <p class="auth__eyebrow">SaaS Admin</p>
      <h2 class="auth__title"><%= _lcs( 'Du bist abgemeldet' ) %></h2>
      <p class="auth__subtitle"><%= _lcs( 'Deine Sitzung wurde sicher beendet. Bis bald!' ) %></p>

      <button class="btn btn--primary btn--block" type="button" data-id="btn-back-to-login">
        <i class="icon icon--arrow-left"></i>
        <%= _lcs( 'Zurück zur Anmeldung' ) %>
      </button>

      <div class="auth__hr"><%= _lcs( 'Geschützter Bereich' ) %></div>
      <p class="auth__note"><%= _lcs( 'BELTURO Cloud — Interner Operator-Zugang.' ) %></p>
    </div>
  </section>
</main>
